<ng-container>

    <a class="button-item" [attr.href]="item.url" (click)="itemClick($event)"
        *ngIf="(!item.routerLink || item.items) && (item.visible)?.hasAccess !== false"
        (mouseenter)="onMouseEnter()" (keydown.enter)="itemClick($event)" [attr.target]="item.target"
        [attr.tabindex]="0" [ngClass]="item.class">
        <div class="container-menuitem align-items-center flex">
            <div>
                <i [ngClass]="((active && appMain.activeIcon && item?.iconClass) ? item.iconClass:item.icon )"
                    class="layout-menuitem-icon" [ngStyle]="{'position':isClosed?'static':'absolute',
                 'margin-top':isClosed?'4px':'-0.5em'}"></i>
            </div>
            <span class="menuitem-text" [class.side-close]="!isClosed" style="padding-left:2px">{{item.label}} </span>
        </div>

    </a>

    <a class="button-item" (click)="itemClick($event)" (mouseenter)="onMouseEnter()"
        *ngIf="(item.routerLink && !item.items) && (item.visible)?.hasAccess !== false"
        [routerLink]="item.routerLink" routerLinkActive="active-menuitem-routerlink" [ngClass]="item.class"
        [routerLinkActiveOptions]="{exact: !item.preventExact}" [attr.target]="item.target" [attr.tabindex]="0">
        <div class="container-menuitem align-items-center flex">
            <div>
                <i [ngClass]="item.icon" class="layout-menuitem-icon" [ngStyle]="{'position':isClosed?'static':'absolute',
                'margin-top':isClosed?'4px':'-0.5em'}"></i>
            </div>
            <span class="menuitem-text" [class.side-close]="!isClosed" style="padding-left: 2px">{{item.label}}</span>
        </div>
    </a>

    <ul *ngIf="(item.items && active) && item.visible !== false" [@children]="(appMain.isHorizontal() && root) ? (active ? 'visible' : 'hidden') :
      (active ? 'visibleAnimated' : 'hiddenAnimated')">
        <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
            <li app-menuitem [item]="child" [index]="i" [parentKey]="key" class="menu-subitem"></li>
        </ng-template>
    </ul>
</ng-container>